import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@/utils/classUtils';
import React, { useEffect, useRef } from 'react';
import { ODP_ACTION_MEDIA_PAUSE, ODP_ACTION_MEDIA_PLAY, ODP_ACTION_MEDIA_VOLUME_SET, ODP_EVENT_TYPE_MEDIA, useOdp, } from '@/providers/OdpProvider';
const BynderAudio = React.forwardRef(({ audio, className }, externalRef) => {
    const { sendOdpEvent, registerOdpEntity } = useOdp();
    const audioRef = useRef(null);
    const previousMutedState = useRef(false);
    const src = audio.content.original;
    useEffect(() => {
        if (src) {
            registerOdpEntity({
                entityType: 'cms_media_items',
                properties: {
                    media_id: audio?.content.assetId,
                    media_url: src,
                    media_type: 'Podcast',
                    media_provider: 'Bynder',
                },
            });
        }
    }, [registerOdpEntity]);
    if (!src) {
        console.warn('BynderAudio: missing original audio src', audio);
        return null;
    }
    const sendAudioOdpEvent = (action, additionalProps = {}) => {
        sendOdpEvent(audio?.eventData, ODP_EVENT_TYPE_MEDIA, {
            action,
            media_play_duration: audioRef?.current?.currentTime || 0,
            ...additionalProps,
        });
    };
    const handleVolumeChange = () => {
        if (!audioRef.current)
            return;
        const isMuted = audioRef.current.muted || audioRef.current.volume === 0;
        const wasMuted = previousMutedState.current;
        // Only send event if mute state changed
        if (isMuted !== wasMuted) {
            sendAudioOdpEvent(ODP_ACTION_MEDIA_VOLUME_SET, {
                is_muted: isMuted,
            });
            previousMutedState.current = isMuted;
        }
    };
    return (
    // TODO(a11y, WCAG 1.2.1): prerecorded audio needs a text alternative. BynderCmsAudioAsset
    // exposes no transcript field, so this needs a CMS schema change before it can be rendered.
    // Deliberately left un-suppressed — `jsx-a11y/media-has-caption` is set to `warn` so this
    // stays visible in CI until that lands.
    _jsxs("audio", { ref: (node) => {
            audioRef.current = node;
            if (!externalRef)
                return;
            if (typeof externalRef === 'function') {
                externalRef(node);
            }
            else {
                externalRef.current = node;
            }
        }, controls: true, preload: "none", onPlay: () => sendAudioOdpEvent(ODP_ACTION_MEDIA_PLAY), onPause: () => sendAudioOdpEvent(ODP_ACTION_MEDIA_PAUSE), onVolumeChange: handleVolumeChange, "aria-label": audio.content.description || 'Audio player', className: cn('w-full', className), children: [_jsx("source", { src: src, type: "audio/mpeg" }), "Your browser does not support the audio element."] }));
});
BynderAudio.displayName = 'BynderAudio';
export default BynderAudio;
